import { render, staticRenderFns } from "./indexRecorridos.vue?vue&type=template&id=3cfc5cd7&"
import script from "./indexRecorridos.vue?vue&type=script&lang=ts&"
export * from "./indexRecorridos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports